<template>
    <login-layout class="view-error">
        <v-card-text>
            <v-alert prominent type="error">{{$route.params.message || 'Oops, something goes wrong'}}</v-alert>
            <v-btn text @click="$router.go(-1)">Go back</v-btn>
        </v-card-text>
    </login-layout>
</template>

<script>
    export default {
        name: "Error",

        mounted() {
            this.$store.commit('loadingOff')
        }
    }
</script>

<style scoped>

</style>
